import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CourtService } from '@shared/services/court.service';
import { ButtonComponent } from '@shared/components/button';
import { IconDirective } from '@ui/components/icon';
import { LoginModalComponent } from '@domains/auth/components/login-modal';
import { AuthService } from '@app/core/services/auth/auth.service';
import { LOGIN_MODAL_SOURCES } from '@domains/auth/components/login-modal';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { TenantInitialNavigationService } from '@shared/services/tenant-initial-navigation.service';
import { Role } from '@shared/enums/role.enum';

import { RegisterModal } from '@shared/components/register-modal';

@Component({
  selector: 'app-account-page',
  imports: [ButtonComponent, IconDirective],
  templateUrl: './account-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountPageComponent {
  private readonly dialog = inject(Dialog);

  private readonly tenantService = inject(TenantFacadeService);
  private readonly authService = inject(AuthService);
  private readonly courtService = inject(CourtService);
  private readonly navigationService = inject(TenantInitialNavigationService);

  protected readonly court = this.courtService.court;

  protected openRegister() {
    this.dialog.open(RegisterModal);
  }

  protected showLogin = () => {
    if (this.authService.isAuthenticated()) {
      this.navigationService.unAwareNavigateTo(
        this.tenantService.tenantEventNavigationPaths()?.subscriber
          ?.fromRegister || '',
      );
      return;
    }
    this.dialog.open(LoginModalComponent, {
      data: {
        source: LOGIN_MODAL_SOURCES.account_view,
        role: Role.Subscriber,
      },
    });
  };
}
